import { useOutletContext } from "react-router";

import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { VcsProvider } from "types/generated";
import { SpacesContext } from "views/Account/SpacesProvider";

import { useLayoutActions } from "../../hooks/useLayoutActions";
import { useLayoutHeading } from "../../hooks/useLayoutHeading";
import { IntegrationsOutletContext } from "../../types";
import VCSIntegrationsList from "../shared/VcsList";
import SetupButton from "../shared/VcsList/SetupButton";
import useSearchVcsIntegrations from "../shared/VcsList/useSearchVCSIntegrations";

const AzureDevOps = () => {
  const provider = VcsProvider.AzureDevops;
  const { hasEntityCreateAccess } = useTypedContext(SpacesContext);
  const { integration } = useOutletContext<IntegrationsOutletContext>();

  useTitle(integration.name);
  useLayoutHeading(integration.name);

  useLayoutActions(hasEntityCreateAccess ? <SetupButton provider={provider} /> : undefined);

  const VcsListProps = useSearchVcsIntegrations([provider]);

  return <VCSIntegrationsList {...VcsListProps} provider={provider} />;
};

export default AzureDevOps;
